import React from "react";
import Classes from "./WhyChooseUs.module.css";
import SparklesIcon, { BuildingIcon, CloudUploadIcon, GlobeIcon, TrendUpIcon } from "../../../../../utils/Icons";

// tiny inline SVG icons (match the look; you can replace anytime)
const SearchIcon = () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="11" cy="11" r="6.5" stroke="#f5b100" strokeWidth="2" />
        <path d="M16 16l5 5" stroke="#f5b100" strokeWidth="2" strokeLinecap="round" />
    </svg>
);

const SheetIcon = () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="5" y="3" width="14" height="18" rx="2" stroke="#f5b100" strokeWidth="2" />
        <path d="M8 8h8M8 12h8M8 16h6" stroke="#f5b100" strokeWidth="2" strokeLinecap="round" />
    </svg>
);

const ListIcon = () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M9 6h10M9 12h10M9 18h10" stroke="#f5b100" strokeWidth="2" strokeLinecap="round" />
        <circle cx="5" cy="6" r="1.5" fill="#f5b100" />
        <circle cx="5" cy="12" r="1.5" fill="#f5b100" />
        <circle cx="5" cy="18" r="1.5" fill="#f5b100" />
    </svg>
);

export default function WhyChooseUs() {
    return (
        <section id="features" className={`${Classes.features} layoutPadding`}>
            {/* Badge */}
            <div className='badge'>
                <SparklesIcon size={17} color='var(--secondary-color)' />
                Why Choose Us
            </div>

            {/* Heading + sub */}
            <h2 className='homeTitle'> Why Partner With Us </h2>
            <p className='homeSubTitle'>
                Everything you need to find, compare, and export lighting specifications—streamlined into one simple interface built for architectural precision.
            </p>

            {/* Cards */}
            <div className={Classes.grid}>
                <article className={Classes.card}>
                    <div className={Classes.cardIcon}>
                        <img src="/assets/icons/globe.png" height={20} alt="globe" />
                    </div>
                    <h3 className={Classes.cardTitle}>Global Exposure</h3>
                    <p className={Classes.cardText}>
                        Feature your lighting products to a worldwide network of architects, designers, and industry professionals.
                    </p>
                </article>

                <article className={Classes.card}>
                    <div className={Classes.cardIcon}>
                        <img src="/assets/icons/graph.png" height={15} alt="globe" />
                    </div>
                    <h3 className={Classes.cardTitle}>Data-Driven Insights</h3>
                    <p className={Classes.cardText}>
                        Access detailed analytics on product views, clicks, downloads, and customer engagement trends.
                    </p>
                </article>

                <article className={Classes.card}>
                    <div className={Classes.cardIcon}>
                        <img src="/assets/icons/upload.png" height={20} alt="globe" />
                    </div>
                    <h3 className={Classes.cardTitle}>Effortless Upload Process</h3>
                    <p className={Classes.cardText}>
                        Feature your lighting products to a worldwide network of architects, designers, and industry professionals.
                    </p>
                </article>

                <article className={Classes.card}>
                    <div className={Classes.cardIcon}>
                        <img src="/assets/icons/building.png" height={20} alt="globe" />
                    </div>
                    <h3 className={Classes.cardTitle}>Showcase Your Brand</h3>
                    <p className={Classes.cardText}>
                        Maintain and display your entire product line in one professional, searchable profile.
                    </p>
                </article>
            </div>

        </section>
    );
}
